import { useRef } from 'react';

import { API_ENDPOINTS } from './common';

/** Channel fetch channel for the given channelId
 * 
 * 
 * @param {string} channelId - the channel identifier
 * @returns channel data 
 */
export function Channel (channelId) {
    const channel = useRef();

    // Fetch segment
    const fetchChannel = async () => {
        const channelData = await fetch(API_ENDPOINTS.channel(channelId), {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            if (response.status >= 400) {
                console.log(response);
                throw new Error("Server respond with error !");
            }
            else {
                return response.json();
            }
        });
        channel.current = channelData;
        return channel.current;
    };
   return {
        fetchChannel,
        channel
    };
}